import { render } from "./bHoliday.vue?vue&type=template&id=1bbd2bd3"
import script from "./bHoliday.vue?vue&type=script&lang=js"
export * from "./bHoliday.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__